import { ErrorBoundary } from "react-error-boundary";
import GlobalFooter from "./components/layout/footer";
import GlobalHeader from "./components/layout/header";
import AppRouter from "./router";
import { Toaster } from "./components/ui/toast";

// TODO
// button in company edit form
// table option & word limit & indication (135/500) in text editor
// multiple docs upload allow
// remove description from why choose us
// list page for company edit in dashboard

function App() {
  return (
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      <Toaster />
      <GlobalHeader />
      <AppRouter />
      <GlobalFooter />
    </ErrorBoundary>
  );
}

export default App;
